import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const PHONE = "919766990448";
const MESSAGE = encodeURIComponent("Hi IncInk! I'd like to chat about a project.");
const HREF = `https://wa.me/${PHONE}?text=${MESSAGE}`;

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  const [tipOpen, setTipOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll);
    // Auto-show tooltip once after 3s
    const t = setTimeout(() => setTipOpen(true), 3000);
    const t2 = setTimeout(() => setTipOpen(false), 9000);
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(t);
      clearTimeout(t2);
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.8 }}
          transition={{ type: "spring", stiffness: 260, damping: 22 }}
          className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[60] flex items-end gap-3"
          data-testid="whatsapp-floating-wrapper"
        >
          <AnimatePresence>
            {tipOpen && (
              <motion.div
                initial={{ opacity: 0, x: 12 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 12 }}
                className="hidden sm:flex items-center gap-2 mb-2 brut-border brut-shadow-sm bg-white px-3 py-2 font-display font-bold text-sm uppercase tracking-wide"
              >
                Let&apos;s chat
                <span className="text-[#25D366]">✦</span>
                <button
                  onClick={() => setTipOpen(false)}
                  className="ml-1 text-[#4A4A4A] hover:text-[#0D0D0D]"
                  aria-label="Dismiss"
                  data-testid="whatsapp-tip-close"
                >
                  ×
                </button>
              </motion.div>
            )}
          </AnimatePresence>

          <a
            href={HREF}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-floating-btn"
            aria-label="Chat on WhatsApp"
            className="group relative w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-[#25D366] brut-border brut-shadow brut-press"
          >
            <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-[#FF0055] brut-border rounded-full animate-pulse" />
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="white"
              aria-hidden="true"
            >
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.464 3.488" />
            </svg>
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
